document.addEventListener('DOMContentLoaded', function () {
    const carouselTrack = document.querySelector('.carousel-track');
    const carouselItems = document.querySelectorAll('.carousel-item');
    const prevButton = document.querySelector('.carousel-button-left');
    const nextButton = document.querySelector('.carousel-button-right');

    let currentIndex = 0;
    let itemWidth = carouselItems[0].offsetWidth;
    let gap = 15;
    let touchListenersAdded = false;

    function updateSlidePosition() {
        const translateXValue = -currentIndex * (itemWidth + gap);
        carouselTrack.style.transform = `translateX(${translateXValue}px)`;
    }

    function moveCarousel(direction) {
        currentIndex = direction === 'prev' ? Math.max(currentIndex - 1, 0) : Math.min(currentIndex + 1, carouselItems.length - 1);
        updateSlidePosition();
    }

    prevButton.addEventListener('click', () => moveCarousel('prev'));
    nextButton.addEventListener('click', () => moveCarousel('next'));

    function manageTouchListeners(action) {
        const method = action === 'add' ? 'addEventListener' : 'removeEventListener';
        let startX = 0;
        let isDragging = false;
        let threshold = 50;

        function onTouchStart(e) {
            startX = e.touches[0].clientX;
            isDragging = true;
        }

        function onTouchMove(e) {
            if (!isDragging) return;
            const currentX = e.touches[0].clientX;
            const diffX = startX - currentX;
            if (Math.abs(diffX) > threshold) {
                if (diffX > 0) {
                    moveCarousel('next');
                } else {
                    moveCarousel('prev');
                }
                isDragging = false;
            }
        }
        function onTouchEnd() {
            isDragging = false;
        }

        carouselTrack[method]('touchstart', onTouchStart);
        carouselTrack[method]('touchmove', onTouchMove);
        carouselTrack[method]('touchend', onTouchEnd);
    }

    function handleTouchEvents() {
        if (window.innerWidth < 960 && !touchListenersAdded) {
            manageTouchListeners('add');
            touchListenersAdded = true;
        } else if (window.innerWidth >= 960 && touchListenersAdded) {
            manageTouchListeners('remove');
            touchListenersAdded = false;
        }
    }

    function handleResize() {
        setTimeout(() => {
            itemWidth = window.innerWidth <= 410 ? 260 : carouselItems[0].offsetWidth;
            gap = window.innerWidth <= 410 ? 60 : 15;
            currentIndex = Math.min(currentIndex, carouselItems.length - 1);
            updateSlidePosition();
            handleTouchEvents();
        }, 100);
    }
    function setCarouselTrackWidth() {
        const totalWidth = carouselItems.length * (itemWidth + gap);
        carouselTrack.style.width = `${totalWidth}px`;
    }

    window.addEventListener('resize', handleResize);
    handleResize();
    setCarouselTrackWidth();
});